import React from 'react';
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import { formatToDutchDate } from '../utils/formatDate';

function DateFormatter({ date }) {
  if (!date || isNaN(new Date(date).getTime())) return 'N/A';
  return format(new Date(date), "dd-MM-yyyy", { locale: nl });
}

export default DateFormatter;